// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"WarmupItem_Wrap__2YPvo","Icon":"WarmupItem_Icon__2tdF_","Block":"WarmupItem_Block__25EFa","pounds":"WarmupItem_pounds__2N7aX","plates":"WarmupItem_plates__35C8c"};